import kr from 'Kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class IndividualImplementationTable extends kr.Component {
    init() {
        this.pxEnabled = 993;
        this.isEnabled = false;

        this.names = this._setNames();
        this.values = this.$element.querySelectorAll('[data-values]');
        this._check(); 

        this._event();
    }

    _event() {
        let bound = false;
        window.addEventListener('resize', () => {
            console.log('t');
            if (bound) {
                return false;
            }

            bound = true;
            this._check();

            setTimeout(() => {
                bound = false;
            }, 50);
        });
    }

    _check()
    {
        if (!this.isEnabled && this.pxEnabled >= window.innerWidth) {
            this._enable();
        } else if (this.isEnabled && this.pxEnabled < window.innerWidth) {
            this._disable();
        }
    }

    _enable()
    {
        for (let group of this.values) {
            for (let row of group.querySelectorAll('[data-group]')) {
                const groupId = row.getAttribute('data-group');
                const name = this.names[groupId];
                const value = row.innerHTML;
                const spanLabel = document.createElement('span');
                HTMLClass.addClass(spanLabel, 'js-label');
                spanLabel.innerHTML = name;
                const spanValue = document.createElement('span');
                HTMLClass.addClass(spanValue, 'js-value');
                spanValue.innerHTML = value;
                row.innerHTML = '';
                row.append(spanLabel);
                row.append(spanValue);
                
            }
        }
        this.isEnabled = true;
    }


    _disable()
    {
        console.log(1);
        for (let group of this.values) {
            for (let row of group.querySelectorAll('[data-group]')) {
                const value = row.querySelector('.js-value').innerHTML;
                row.innerHTML = value;
            }
        }
        this.isEnabled = false;
    }

    _setNames()
    {
        const groups = this.$element.querySelectorAll('[data-groups] [data-group]');
        let array = [];
        for (let item of groups) {
            array[item.getAttribute('data-group')] = item.innerHTML;
        }
        
        return array;
    }

}

kr.registerComponent('.js-iw-resptable', {
    component: IndividualImplementationTable
});
